import { Ng2StateDeclaration } from '@uirouter/angular';
import { DocumentListViewStateComponent } from '@fi-app/document/document-list-view-state/document-list-view-state.component';
import { PageTitleService } from '@fi-app/utilities/fi-services/page-title.service';
import { ObjectTypes } from '@fi-shared/types/object-type';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';

export const FiDocumentListState: Ng2StateDeclaration = {
    name: FiStateNames.Document.List,
    url: '/?:sortColumn&:sortDirection&:offset',
    component: DocumentListViewStateComponent,
    reloadOnSearch: false,
    resolve: {
        pageTitle: [PageTitleService, FiDocumentListStateResolvePageTitleResolveFunc],
    },
};

export function FiDocumentListStateResolvePageTitleResolveFunc(pageTitleService: PageTitleService) {
    return pageTitleService.setTitleByItem(ObjectTypes.Document);
}
